"use strict";import{css as t}from"@spectrum-web-components/base";const o=t`
    .spectrum{color:var(--spectrum-body-m-text-color,var(--spectrum-alias-text-color));font-family:var(--spectrum-alias-body-text-font-family,var(--spectrum-global-font-family-base));font-size:var(--spectrum-alias-font-size-default,var(--spectrum-global-dimension-font-size-100))}
`;export default o;
//# sourceMappingURL=spectrum-base.css.js.map
